export class MetaData {
    /**@type {bool}isPatternFilled */
    isPatternFilled = false;

    constructor(isPatternFilled) {
        this.isPatternFilled = isPatternFilled;
    }
}
